import React from 'react';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Description from './Description';
import { Markdown } from '../../General/Markdown';
import { replaceAll } from '../../../Helpers/String';
import ResultIcon from '../ResultIcon';
import { Rule } from '../../../Interface/Response/Validator/Results/Review/Response/Rule';
import { sortAcceptanceFeatures } from '../../../Helpers/Sort';

interface Props {
    scope: Rule[];
}

const ScopeDetails: React.FC<Props> = Props => {
    const { scope } = Props;
    scope.sort(sortAcceptanceFeatures);

    return (
        <Container className="scope-details" fluid>
            <Row className="scope-details__header">
                <Col md={1} className="col col-result" />
                <Col md={3} className="col">
                    Onderwerp
                </Col>
                <Col md={2} className="col">
                    Referentie
                </Col>
                <Col md={4} className="col">
                    Toelichting
                </Col>
                <Col md={2} className="col">
                    Beleidstekst
                </Col>
            </Row>
            {scope.map((rule, index) => (
                <Row key={index} className="scope-details__detail">
                    <Col className="icon col col-result" md={1}>
                        <ResultIcon active color={rule.resultaat} />
                    </Col>
                    <Col md={3} className="col">
                        {rule.naam}
                    </Col>
                    <Col md={2} className="col">
                        {replaceAll(replaceAll(rule.referentie, '[', ' '), ']', '')
                            .split('/')
                            .map((ref, i) => (
                                <div key={i}>{ref}</div>
                            ))}
                    </Col>
                    <Col md={4} className="col">
                        <Description
                            aanvullendeInformatie={rule.aanvullendeInformatie}
                            omschrijving={rule.omschrijving}
                        />
                    </Col>
                    <Col md={2} className="col">
                        {rule.beleidstekst !== null && <Markdown text={rule.beleidstekst || ''} />}
                    </Col>
                </Row>
            ))}
        </Container>
    );
};

export default ScopeDetails;
